<template>
  <li class="clinic-sidebar__list-child" :class="{ '--active': isActive }">
    <slot name="sub-item-body" />
  </li>
</template>

<script>
export default {
  props: {
    pettechoActivePaths: {
      type: Array,
      default: () => [],
    },
    pettechoInactivePaths: {
      type: Array,
      default: () => [],
    },
    onlineReceptionActivePaths: {
      type: Array,
      default: () => [],
    },
    onlineReceptionInactivePaths: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      onlineReceptionPath: '',
    };
  },
  computed: {
    isActive() {
      const pettechoPath = location.pathname;
      const onlineReceptionPath = this.onlineReceptionPath;
      return (
        (this.pettechoActivePaths.length == 0 || this.pettechoActivePaths.includes(pettechoPath)) &&
        (this.pettechoInactivePaths.length == 0 || !this.pettechoInactivePaths.includes(pettechoPath)) &&
        (this.onlineReceptionActivePaths.length == 0 ||
          this.onlineReceptionActivePaths.includes(onlineReceptionPath)) &&
        (this.onlineReceptionInactivePaths.length == 0 ||
          // チラつき防止の為、条件（&& onlineReceptionPath != ''）を追加
          (!this.onlineReceptionInactivePaths.includes(onlineReceptionPath) &&
            onlineReceptionPath != ''))
      );
    },
  },
  mounted() {
    window.addEventListener('message', (e) => {
      this.receiveOnlineReceptionPath(e);
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', (e) => {
      this.receiveOnlineReceptionPath(e);
    });
  },
  methods: {
    receiveOnlineReceptionPath(e) {
      if (e.data.action == 'postOnlineReceptionPath') {
        this.onlineReceptionPath = e.data.message;
      }
    },
  },
};
</script>
